var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 512,
    viewBox: "0 0 1024 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_105_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H682.667V512H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 0L340.267 193.067L599.467 0H682.667V66.1333L426.667 257.067L682.667 446.933V512H597.333L341.333 321.067L86.4 512H0V448L254.933 258.133L0 68.2667V0H80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.267 299.733L682.667 469.333V512L393.6 299.733H452.267ZM256 321.067L262.4 358.4L57.6 512H0L256 321.067ZM682.667 0V3.2L417.067 203.733L419.2 156.8L629.333 0H682.667ZM0 0L254.933 187.733H190.933L0 44.8V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.067 0V512H427.733V0H257.067ZM0 170.667V341.333H682.667V170.667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 205.867V308.267H682.667V205.867H0ZM291.2 0V512H393.6V0H291.2Z",
    fill: "#C8102E"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 683,
    height: 512,
    fill: "url(#paint0_linear_105_45)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 512,
    fill: "url(#paint1_linear_105_45)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M806.647 443V475H796V443C796 428.272 807.917 416.333 822.618 416.333C829.383 416.333 835.558 418.862 840.254 423.027C844.023 412.888 853.773 405.667 865.206 405.667C871.971 405.667 878.146 408.195 882.842 412.36C886.611 402.221 896.361 395 907.794 395C922.494 395 934.411 406.938 934.412 421.665C938.86 418.317 944.39 416.333 950.382 416.333C965.083 416.333 977 428.272 977 443V475H966.353V443C966.353 434.163 959.203 427 950.382 427C941.562 427 934.412 434.163 934.412 442.999V464.333H923.765V421.667C923.765 412.83 916.615 405.667 907.794 405.667C898.974 405.667 891.824 412.83 891.824 421.666V453.667H881.176V432.333C881.176 423.496 874.026 416.333 865.206 416.333C856.386 416.333 849.235 423.496 849.235 432.333V464.333H838.588V442.999C838.588 434.163 831.438 427 822.618 427C813.797 427 806.647 434.163 806.647 443V443ZM950.382 384.333C957.728 384.333 963.691 390.308 963.691 397.667C963.691 405.026 957.728 411 950.382 411C943.037 411 937.074 405.026 937.074 397.667C937.074 390.308 943.037 384.333 950.382 384.333ZM822.618 384.333C829.963 384.333 835.926 390.308 835.926 397.667C835.926 405.026 829.963 411 822.618 411C815.272 411 809.309 405.026 809.309 397.667C809.309 390.308 815.272 384.333 822.618 384.333ZM865.206 373.667C872.551 373.667 878.515 379.641 878.515 387C878.515 394.359 872.551 400.333 865.206 400.333C857.86 400.333 851.897 394.359 851.897 387C851.897 379.641 857.86 373.667 865.206 373.667ZM907.794 363C915.14 363 921.103 368.974 921.103 376.333C921.103 383.692 915.14 389.667 907.794 389.667C900.449 389.667 894.485 383.692 894.485 376.333C894.485 368.974 900.449 363 907.794 363V363Z",
    fill: "#F39C12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_45",
    x1: 0,
    y1: 0,
    x2: 491.453,
    y2: 655.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_105_45",
    x1: 563.5,
    y1: 235.5,
    x2: -12.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278654,
    stopColor: "#112A44",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_105_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682.667,
    height: 512,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.0dd0a7cb86c8edd8afea0d3d83b44d00.svg";
export { ForwardRef as ReactComponent };